// A shift's cues, as the server deals and judges them (Jobs::Cues in
// app/models/jobs.rb). The dice are the Lists' mulberry32, so the float dips
// here at the instant the server will say it dipped; the verdict drawn here
// is a preview, and the pay is the server's word.

import { seedOf, dice } from "../lists/tilt.js"

export const SHARP_POINTS = 2
export const HIT_POINTS = 1
export const FIRST_MS = 2200
export const FIRST_SPREAD_MS = 1500
export const GAP_MS = 2600
export const GAP_SPREAD_MS = 3200
export const BEAT_MS = 640
export const BEATS = 3
export const TAIL_MS = 2500
export const SPOT_REACH = 0.13

// job: { game, cues, windowMs, sharpMs } as the server hands it with the shift.
export function deal(seedHex, job) {
  const roll = dice(seedOf(seedHex))
  const cues = []
  let at = FIRST_MS + Math.round(roll() * FIRST_SPREAD_MS)

  while (cues.length < job.cues) {
    const x = 0.12 + roll() * 0.76
    const y = 0.18 + roll() * 0.64
    if (job.game === "strike") {
      for (let beat = 0; beat < BEATS; beat++) {
        if (cues.length >= job.cues) break
        cues.push({ at: at + beat * BEAT_MS, x, y })
      }
      at += (BEATS - 1) * BEAT_MS
    } else {
      cues.push({ at, x, y })
    }
    at += GAP_MS + Math.round(roll() * GAP_SPREAD_MS)
  }

  return cues
}

export function lengthMs(cues, job) {
  const last = cues[cues.length - 1].at
  return last + (job.game === "spot" ? job.windowMs : 0) + TAIL_MS
}

// The server's judging, cue by cue: the nearest unspent press inside the
// window takes it. Returns { points, marks: ["sharp"|"hit"|"miss", ...] }.
export function judge(cues, presses, job) {
  const spent = new Set()
  const marks = cues.map((cue) => {
    let best = null
    presses.forEach((press, index) => {
      if (spent.has(index)) return
      const offset = press.ms - cue.at
      const inside = job.game === "spot"
        ? offset >= 0 && offset <= job.windowMs && Math.hypot(press.x - cue.x, press.y - cue.y) <= SPOT_REACH
        : Math.abs(offset) <= job.windowMs
      if (!inside) return
      if (best === null || Math.abs(offset) < best.offset) best = { index, offset: Math.abs(offset) }
    })
    if (best === null) return "miss"
    spent.add(best.index)
    return best.offset <= job.sharpMs ? "sharp" : "hit"
  })

  const points = marks.reduce((sum, mark) => sum + (mark === "sharp" ? SHARP_POINTS : mark === "hit" ? HIT_POINTS : 0), 0)
  return { points, marks }
}

// One press against the cues as they stand at that moment — for the flash
// the browser shows before the server has spoken. Returns "sharp", "hit" or
// "miss" and the cue it landed on, if any.
export function preview(cues, press, job, spentIndexes = new Set()) {
  let best = null
  cues.forEach((cue, index) => {
    if (spentIndexes.has(index)) return
    const offset = press.ms - cue.at
    const inside = job.game === "spot"
      ? offset >= 0 && offset <= job.windowMs && Math.hypot(press.x - cue.x, press.y - cue.y) <= SPOT_REACH
      : Math.abs(offset) <= job.windowMs
    if (!inside) return
    if (best === null || Math.abs(offset) < best.offset) best = { index, offset: Math.abs(offset) }
  })
  if (best === null) return { mark: "miss", index: null }
  return { mark: best.offset <= job.sharpMs ? "sharp" : "hit", index: best.index }
}
